import { formatDateString } from '@/main/helpers'
import {
  EnrollmentWindowApiResponse,
  EnrollmentWindowModel,
  RegisterInterestApiResponse,
  RegisterInterestModel
} from './enrollment-window-service-types'

export const formatEnrollmentWindow = (
  data: EnrollmentWindowApiResponse
): EnrollmentWindowModel => ({
  blocked: data.blocked,
  reason: data.reason ?? null,
  opensAt: formatDateString(data.opensAt ?? undefined) ?? null,
  startDate: formatDateString(data.startDate ?? undefined) ?? null,
  hasInterest: data.hasInterest
})

export const formatRegisterInterest = (
  data: RegisterInterestApiResponse
): RegisterInterestModel => ({
  hasInterest: data.hasInterest,
  reason: data.reason,
  status: data.status,
  createdAt: data.createdAt
})
